import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { BankAccountDataService } from '../../services/bank-account-data.service';
import { DynamicItem } from 'src/app/models/dynamicItem';
import { PopupConsentPinComponent } from '../popups/popup-consent-pin/popup-consent-pin.component';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
  selector: 'app-set-nickname',
  templateUrl: './set-nickname.component.html',
  styleUrls: ['./set-nickname.component.scss']
})
export class SetNicknameComponent implements OnInit {

  bankAccountList;
  selectedFip;
  accountDetails;
  popupData: any;
  showPopupFlag: boolean = false;
  checkboxRequired = false;
  breadcrumb: { "label": string; "link": any[]; }[] = [];

  constructor(
    private route: Router,
    private accountService: BankAccountDataService,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.setBreadcrumb();
    this.getSelectedFip();
  }

  getSelectedFip(): void {
    this.selectedFip = this.accountService.getSelectedFip();
    this.accountDetails = this.accountService.getLinkRequestedAccounts();
  }

  setBreadcrumb() {
    this.breadcrumb = [
      { "label": "Set Nicknames", "link": ["/link-account"] },
    ];
  }

  initiateAccountLinkAPI() {
    var self = this;
    this.showpopup();
    let option = {
      type: 'post',
      url: 'accountlink',
      isDeveloper: true,
      includeUserSession: true,
      data: this.accountDetails
    }
    this.accountService.linkDiscoveredAccounts(option, function () {
      //if (self.selectedFip.FIPID != '8') {
        self.showpopup();
      /*} else {
        self.route.navigate(['/dashboard']);
      }*/
    });
  }

  /**
   * To show Popup, we are changing ngIf to true and preparing data
   */
  showpopup() {
    let popuptext: any = {
      heading: "OTP for Linking Accounts ",
      body: "Please provide OTP to link Accounts",
      successCallback: this.accountLinkConfirm.bind(this),
      cancelCallback: this.closePopup.bind(this)
    }
    this.popupData = new DynamicItem(PopupConsentPinComponent, popuptext);
    this.showPopupFlag = true;
  }

  /**
   * To hide Popup, we are changing ngIf to false.
   */
  closePopup() {
    this.showPopupFlag = false;
  }

  /**
   * 
   * @param data - pin entered in the linking popup
   * Function to confirm the linking , calling this change pending linked account status to linked.
   */
  accountLinkConfirm(data) {
    this.closePopup();
    if (data.length == 6) {

      let option = {
        type: 'post',
        url: 'accountlinkconfirm',
        isDeveloper: true,
        includeUserSession: true,
        data: {}
      }
      if (this.selectedFip.FIPID == '7' || this.selectedFip.FIPID == '8') {
        option = {
          type: 'post',
          url: 'accountotp',
          isDeveloper: true,
          includeUserSession: true,
          data: {
            "otp": data,
            "RefNumber": this.accountService.getLinkedAccounts().data.RefNumber,//this.selectedFip this.selectedFip this.selectedFip
            "fipID": this.selectedFip.FIPID == '7' ? "kotak" : "icici"
          }
        }
      } else {
        option['data'] = { "eventID": this.accountService.getLinkedAccounts() ? this.accountService.getLinkedAccounts().eventID : '', }

      }

      let that = this;
      this.accountService.accountlinkingconfirm(option, function (data) {
        if (data.message == "Otp validate success.") {
          that.showGlobalPopup("Otp validate success.");
          that.route.navigate(['/linked-account']);
        } else {
          that.showGlobalPopup("Otp validate fail.");
        }
        //that.route.navigate(['/linked-account']);
      });
    } else {
      this.showGlobalPopup("Please enter valid PIN...");
    }
  }

  /**
   * To build and show global message popup
   * @param body popup body message
   * @param heading popup heading message
   */
  showGlobalPopup(body: string, heading?: string) {
    let popuptext = {
      heading: heading || "OnemoneyAA",
      body: body
    }

    this.commonService.showGlobalMessage(popuptext);
  }

}